import { Button, Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["item"];

// const items = [
//   {
//     id: 1,
//     Item: "200",
//   },
// ];

function Policies() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);
  const navigate = useNavigate();

  const onNew = () => {
    navigate("/PolicieAdd");
  };

  const onSelectItm = (data) => {
    // setSelectedItem(data);
    //  navigate("/PolicieAdd");
    if (data?.item) {
      navigate("/PolicieAdd", {
        state: { action: "policieadd-edit", data: data?.item?.data },
      });
    }
  };

  const getList = (data) => {
    setIsLoading(true);
    api
      .getPricing({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log("getlkist", res.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.id) {
            let l = res.data.map((item) => {
              let label = "";

              if (item?.covername) {
                label += item?.covername;
                label += " ";
              }

              if (item?.durationvalue) {
                label += item?.durationvalue;
                label += " ";
              }

              if (item?.durationtype) {
                label += item?.durationtype;
                label += " ";
              }

              if (item?.purchaselimitamount) {
                label += "Claim ";
                label += item?.purchaselimitamount;
                label += " ";
              }

              return {
                id: item?.id,
                label: label || "",
                data: item,
              };
            });

            l = l.filter((a) => a.label !== "");
            setList(l);
          } else {
            setList([]);
          }
        } else {
          toaster.create({
            title: res?.message || "error",
            type: "error",
          });
        }
      });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Pricing"} isLoading={isLoading} />
      <Flex gap={"1rem"} justifyContent={"flex-end"} mb={"1rem"}>
        {/* <Button variant="outline" onClick={onNew}>
          Open
        </Button> */}
        <Button variant="outline" onClick={onNew}>
          New
        </Button>
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Policies;
